const Point3Illustration = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 0H8C3.58172 0 0 3.58172 0 8V48.0002C0 52.4185 3.58172 56.0002 8 56.0002H48C52.4183 56.0002 56 52.4185 56 48.0002V8C56 3.58172 52.4183 0 48 0Z"
      fill="white"
    />
    <path d="M15.9841 0H8.05078V56.0002H15.9841V32.0001V0Z" fill="#FB6E44" />
    <path d="M31.9685 0H24.0352V56.0002H31.9685V32.0001V0Z" fill="#0A0777" />
    <path d="M47.9509 0H40.0176V56.0002H47.9509V32.0001V0Z" fill="#FB6E44" />
    <path
      d="M24.0352 15.9837L24.0352 8.05029L0.00177574 8.05029L0.00177539 15.9837L10.3018 15.9837L24.0352 15.9837Z"
      fill="#FFCCEF"
    />
    <path
      d="M56 15.9837L56 8.05029L31.9666 8.05029L31.9666 15.9837L42.2666 15.9837L56 15.9837Z"
      fill="#FFCCEF"
    />
    <path
      d="M8.05078 31.9671L8.05078 24.0337L0.0007658 24.0337L0.000765454 31.9671L3.45077 31.9671L8.05078 31.9671Z"
      fill="#FFCCEF"
    />
    <path
      d="M56 31.9671L56 24.0337L47.95 24.0337L47.95 31.9671L51.4 31.9671L56 31.9671Z"
      fill="#FFCCEF"
    />
    <path
      d="M40.0176 31.9671L40.0176 24.0337L15.9842 24.0337L15.9842 31.9671L26.2842 31.9671L40.0176 31.9671Z"
      fill="#FFCCEF"
    />
    <path
      d="M24.0352 47.95L24.0352 40.0166L0.00177574 40.0166L0.00177539 47.95L10.3018 47.95L24.0352 47.95Z"
      fill="#FFCCEF"
    />
    <path
      d="M56 47.95L56 40.0166L31.9666 40.0166L31.9666 47.95L42.2666 47.95L56 47.95Z"
      fill="#FFCCEF"
    />
  </svg>
);

export default Point3Illustration;
